import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const LabelCss = css`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: var(--form-label-font-size, 0.9rem);
  font-weight: var(--form-label-font-weight, 500);
  line-height: var(--form-label-line-height, 1.2);
  cursor: pointer;
  user-select: none;
  gap: 0.3em;
`;

export const labelVariants = {
  default: LabelCss,
};

export type ILabelVariants = VariantOfType<typeof labelVariants>;
